<template>
  <a-modal v-model:visible="reasonVisible" width="500px" title="反馈结果" centered>
    <div class="status-list">
      <a-radio-group
        class="z-flex"
        v-model:value="feedResult"
        :options="feedList"
        @change="handleChange"
      ></a-radio-group>
    </div>
    <div style="margin-top: 20px" v-if="feedResult === 100">
      <span style="font-size: 14px; color: #333333; margin-right: 8px">下次跟进时间：</span>
      <a-date-picker v-model:value="nextTime" :disabled-date="disabledDate" />
    </div>
    <template #footer>
      <a-button type="primary" @click="saveThenFinish">提交并完成</a-button>
    </template>
  </a-modal>
</template>
<script setup>
import { defineExpose, ref, defineProps, defineEmits, computed } from 'vue'
import { doctorAssistantSubmitFeedback } from '@/api/workPlace/workOrder'
import { message } from 'ant-design-vue'
import moment from 'moment'

const prop = defineProps({
  info: {
    type: Object,
    default: () => {}
  },
  curGroupInfo: {
    type: Object,
    default: () => {}
  }
})
const groupInfo = computed(() => prop.curGroupInfo)
const reasonVisible = ref(false)
const feedResult = ref(null)
const nextTime = ref()
const feedList = ref([
  { label: '治愈', value: 2 },
  { label: '有效', value: 5 },
  { label: '无效', value: 4 },
  { label: '失访', value: 3 },
  { label: '下次跟进', value: 100 }
])

const disabledDate = current => {
  return current && current < moment()
}

const handleChange = () => {}
const initModal = () => {
  console.log('groupInfo', groupInfo.value)
  feedResult.value = null
  reasonVisible.value = true
}

const emits = defineEmits(['completeBuss'])
const saveThenFinish = () => {
  if (feedResult.value === 100 && !nextTime.value) {
    return message.error('请选择下次跟进时间')
  }
  doctorAssistantSubmitFeedback({
    followUpPlanCardId: prop.info.followUpPlanCardId,
    medicationScheduleId: prop.info.medicationScheduleId,
    privateGroupId: groupInfo.value.assistantPatientGroupId,
    followupType: 2,
    flowResultStatus: feedResult.value,
    medicationEndDate:
      feedResult.value === 100 ? moment(nextTime.value).format('YYYY-MM-DD') : null,
    ucPatientId: groupInfo.value.patientInfo.ucUserId,
    ucDoctorId: groupInfo.value.doctorInfo.ucUserId
  }).then(() => {
    reasonVisible.value = false
    emits('completeBuss')
  })
}
defineExpose({
  initModal
})
</script>
<style scoped lang="scss">
.determine-status {
  justify-content: flex-start;
  &-radio {
    margin-top: 14px;
  }
  .title {
    width: 70px;
    margin-right: 8px;
    text-align: right;
    flex-shrink: 0;
  }
}
</style>
